import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Forward: React.FunctionComponent<Props> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.91797 5.83301L12.0846 9.99967L7.91797 14.1663'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Forward;
